import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const PhilosophyStrip = () => {
  const steps = [
    { num: "01", title: "Understanding the Challenge", text: "We start by listening — getting to the root of the operational problem before talking solutions." },
    { num: "02", title: "Identifying the Opportunity", text: "Industry knowledge turns a challenge into a clear path forward and the right opportunity." },
    { num: "03", title: "Connecting the Solution", text: "We bring the right people, suppliers, and partners together to get the job done." },
  ];
  return (
    <section data-testid="philosophy-section" className="relative bg-black border-y border-white/10">
      <div
        className="absolute inset-0 opacity-20 bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1669003154400-053af9a35eba')" }}
      />
      <div className="absolute inset-0 bg-black/80" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-32">
        <Reveal>
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-blue-500 mb-4">Core Philosophy</p>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tight text-white max-w-3xl leading-[0.95]">
            How we move work forward
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 mt-16 border border-white/10">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 120} className="bg-black p-8 md:p-10 group hover:bg-zinc-900 transition-colors duration-300">
              <span className="font-heading text-6xl font-black text-zinc-800 group-hover:text-blue-600 transition-colors duration-300">
                {s.num}
              </span>
              <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white mt-4">
                {s.title}
              </h3>
              <p className="text-zinc-400 mt-3 leading-relaxed">{s.text}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={200} className="mt-12">
          <Link
            to="/contact"
            data-testid="philosophy-cta"
            className="inline-flex items-center gap-2 font-heading text-lg font-semibold uppercase tracking-widest text-white hover:text-blue-500 transition-colors duration-200 group"
          >
            Let's talk about your challenge
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-200" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
